import { Injectable } from '@angular/core';
import { DcScc } from "dc-scc";
import { Clients } from "./Factories/Clients";
import { Stores } from "./Factories/Stores";
import { Handlers } from "./Factories/Handlers";

@Injectable({
	providedIn: 'root'
})
export class DcDdsApi
{
	protected _storeFact=null;
	protected _handleFact=null;
	protected _clientFact=null;
	
	constructor(
			private _dcScc: DcScc,
	) {
		this._dcScc.getMtm().set("DcDdsApi", this);
	}
	public getDcScc()
	{
		return this._dcScc;
	}
	public getMtm()
	{
		return this.getDcScc().getMtm();
	}
	public getLogging()
	{
		return this.getDcScc().getLogging();
	}
	public getClients()
	{
		if (this._clientFact === null) {
			this._clientFact	= new Clients();
			this._clientFact.setService(this);
			this._clientFact.setExceptionCb(this.getLogging(), "exception");
		}
		return this._clientFact;
	}
	public getStores()
	{
		if (this._storeFact === null) {
			this._storeFact	= new Stores();
			this._storeFact.setService(this);
			this._storeFact.setExceptionCb(this.getLogging(), "exception");
		}
		return this._storeFact;
	}
	public getHandlers()
	{
		if (this._handleFact === null) {
			this._handleFact	= new Handlers();
			this._handleFact.setService(this);
			this._handleFact.setExceptionCb(this.getLogging(), "exception");
		}
		return this._handleFact;
	}
}